import { FeaturesModel } from '@bayclubs/employee-management-api';

export enum FeaturesActionTypes {
    LoadFeatures = '[PM Core] Load features',
    LoadFeaturesSuccess = '[PM Core] Load features success',
}

export class LoadFeaturesAction {
    static readonly type = FeaturesActionTypes.LoadFeatures;
    constructor() { }
}

export class LoadFeaturesSuccessAction {
    static readonly type = FeaturesActionTypes.LoadFeaturesSuccess;
    constructor(public features: FeaturesModel) { }
}